import React from "react";
import { modalBoxStyle } from "../styles";
import {
  Button,
  Typography,
  Box,
  Modal,
  Grid,
  IconButton,
} from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

const OrderToParConfirmationModal = ({
  isOpen,
  closeModal,
  orderToParData,
  orderCallback,
  showNoUnderPar,
}) => {
  const handleOrder = () => {
    orderCallback(true);
  };
  return (
    <Modal
      open={isOpen}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalBoxStyle}>
        <Grid
          container
          direction="column"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid
            container
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Grid item>
              <Typography variant="h2">
                {showNoUnderPar ? "No Products to Order" : "Order to Par"}
              </Typography>
            </Grid>
            <Grid item>
              <IconButton onClick={closeModal}>
                <CloseOutlinedIcon />
              </IconButton>
            </Grid>
          </Grid>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: "column",
              width: "100%",
              marginTop: 4,
            }}
          >
            {showNoUnderPar ? (
              <Typography variant="body1">
                You have no products that are under par, so you are all set!
              </Typography>
            ) : (
              <>
                <Typography variant="body1">
                  While preparing your order, we found{" "}
                  {orderToParData?.orderItemsToAddCount} products to add to your cart.
                </Typography>
                {orderToParData?.recordsMissingInfo?.length > 0 ? (
                  <>
                  <br/>
                  <Typography variant="body1">
                    We also found {orderToParData.recordsMissingInfo?.length}{" "}
                    records that were missing product or vendor information that
                    prevent us from automatically adding them to your order.
                    Ensure products and their formats contain the necessary
                    sizing and purchase unit data to enable automatically adding
                    them to a order.
                  </Typography>
                  </>
                ) : (
                  <></>
                )}
                {orderToParData?.recordsWithNoParCount > 0 ? (
                  <>
                  <br/>
                  <Typography variant="body1">
                    There were {orderToParData.recordsMissingInfo?.length}{" "}
                    records that had no par set and will not be added to the
                    order.
                  </Typography>
                  </>
                ) : (
                  <></>
                )}
                <br/>
                <Typography variant="body1">
                  Would you like to continue?
                </Typography>
              </>
            )}
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "3rem",
              width: "100%",
            }}
          >
            <Button
              variant="outlined"
              onClick={closeModal}
              sx={{ width: "50%", marginRight: 1 }}
            >
              <Typography variant="largeButton">Cancel</Typography>
            </Button>
            <Button
              variant="contained"
              sx={{
                width: "50%",
                height: "40px",
                marginLeft: 1,
              }}
              onClick={handleOrder}
            >
              <Typography variant="largeButton">Confirm</Typography>
            </Button>
          </Box>
        </Grid>
      </Box>
    </Modal>
  );
};

export default OrderToParConfirmationModal;
